// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"styles_footerContainer__32Ste","footerTextContainer":"styles_footerTextContainer__1A7iF"};